export const LIVEKIT_URL =
	import.meta.env.VITE_LIVEKIT_URL || "ws://localhost:7880";
